/**
 * / — the home route now lives under the Ninety section (F58). This is a thin
 * redirect to /ninety (My Ninety) so existing links to "/" keep working.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    throw redirect({ to: '/ninety' });
  },
});
